import { z } from 'zod';
import { api } from '@/lib/api';
import {
  RecommendedJobsResponseSchema,
  type RecommendedJobsResponse,
  DepartmentsResponseSchema,
  type DepartmentsResponse,
  StarterPreviewResponseSchema,
  type StarterPreviewResponse,
} from './schemas';

function tenantHeaders(tenantId: string): Record<string, string> {
  return { 'X-Tenant-Id': tenantId };
}

const VoidSchema = z.void();

export async function dismissWelcome(): Promise<void> {
  await api.post('/auth/welcome/dismiss', VoidSchema, {});
}

export async function dismissCelebration(tenantId: string, memberId: string): Promise<void> {
  await api.post(
    `/tenant/onboarding/members/${encodeURIComponent(memberId)}/celebration/dismiss`,
    VoidSchema,
    {},
    { headers: tenantHeaders(tenantId) },
  );
}

export async function getRecommendedJobs(
  tenantId: string,
  memberId: string,
): Promise<RecommendedJobsResponse> {
  return api.get(
    `/tenant/onboarding/members/${encodeURIComponent(memberId)}/recommended-jobs`,
    RecommendedJobsResponseSchema,
    { headers: tenantHeaders(tenantId) },
  );
}

export async function listSystemDepartments(): Promise<DepartmentsResponse> {
  return api.get('/system/units', DepartmentsResponseSchema);
}

export async function getStarterPreview(departmentIds: string[]): Promise<StarterPreviewResponse> {
  const qs =
    departmentIds.length > 0
      ? `?department_ids=${encodeURIComponent(departmentIds.join(','))}`
      : '';
  return api.get(`/system/starter-preview${qs}`, StarterPreviewResponseSchema);
}
